import React, {useEffect, useRef, useState} from "react";
import {
    AverageOrderTimeRow,
    AvgDeliveryTimeImg,
    AvgOrderTimeLabel,
    AvgOrderTimeValue,
    DeliveryStatsBlock,
    DeliveryStatsIcon,
    DeliveryStatsLabel,
    DeliveryStatsRow,
    DeliveryStatsValue,
    StatsHeader,
    Wrapper
} from "./OrderStats.styles";
import {useHistory} from "react-router-dom";
import AvgDeliveryTimeIcon from "../../../../public/images/avg-delivery-time-icon.svg";
import ActiveOrderIcon from "../../../../public/images/active-order-icon.svg";
import WaitingOrderIcon from "../../../../public/images/waiting-order-icon.svg";
import CanceledOrderIcon from "../../../../public/images/canceled-order-icon.svg";
import DeliveredOrderIcon from "../../../../public/images/delivered-order-icon.svg";
import TotalOrderIcon from "../../../../public/images/total-order-icon.svg";
import {Spin} from "antd";
import {useStore} from "../../../../hooks/useStore";
import {useFetch} from "../../../../hooks/useFetch";
import useIsFocused from "../../../../hooks/useIsFocused";
import {TimeRangeFilter} from "./timeRangeFilter/TimeRangeFilter";
import {isNumeric} from "../../../../utils/helpers";

const RELOAD_INTERVAL = 1000 * 10; //10 seconds

export const OrderStats = ({
    dateType: propDateType,
    startDate: propStartDate,
    endDate: propEndDate,
    onDateChange
}) => {
    const stores = useStore();
    const history = useHistory();
    const isFocused = useIsFocused();

    // Prop'lardan gelen değerleri kullan, yoksa default değerleri kullan
    const [startDate, setStartDate] = useState(propStartDate || "");
    const [endDate, setEndDate] = useState(propEndDate || "");
    const [dateType, setDateType] = useState(propDateType || "daily");

    // Prop'lar değiştiğinde local state'i güncelle
    useEffect(() => {
        if (propStartDate !== undefined) setStartDate(propStartDate);
        if (propEndDate !== undefined) setEndDate(propEndDate);
        if (propDateType !== undefined) setDateType(propDateType);
    }, [propStartDate, propEndDate, propDateType]);

    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    const [loading, statsData, _, __] = useFetch({
        fetchFn: stores.statisticStore.getHistoricStatistics.bind(null, {
            period: "all",
            city: "",
            period: dateType,
            startDate: startDate,
            endDate: endDate
        }),
        defaultDataValue: {},
        initialCall: false,
        dependencies: [recall, dateType, startDate, endDate]
    });

    useEffect(() => {
        setTimeout(() => {
            setRecall(!recallRef.current);
        }, 200);
    }, []);

    useEffect(() => {
        if (isFocused) {
            let timeout = null;

            timeout = setTimeout(() => {
                setRecall(!recallRef.current);
            }, RELOAD_INTERVAL);

            return () => clearTimeout(timeout);
        }
    }, [recall, isFocused]);

    const nullObjectCheck = obj => {
        return JSON.stringify(obj) === JSON.stringify({});
    };
    const renderAvgDeliveryTime = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.averageDeliveryTime)) {
            return "- dk";
        }

        return `${statsData?.averageDeliveryTime} dk`;
    };

    const renderActiveOrderCount = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.onTheWayDeliveryCount)) {
            return "###";
        }

        return statsData?.onTheWayDeliveryCount;
    };

    const renderWaitingOrderCount = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.inQueueDeliveryCount)) {
            return "###";
        }

        return statsData?.inQueueDeliveryCount;
    };

    const renderCanceledOrderCount = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.canceledDeliveryCount)) {
            return "###";
        }

        return statsData?.canceledDeliveryCount;
    };

    const renderDeliveredOrderCount = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.deliveredDeliveryCount)) {
            return "###";
        }

        return statsData?.deliveredDeliveryCount;
    };

    const renderTotalOrderCount = () => {
        if (nullObjectCheck(statsData) || !isNumeric(statsData?.totalOrderCount)) {
            return "###";
        }

        return statsData?.totalOrderCount;
    };

    return (
        <Wrapper>
            <StatsHeader>
                <AverageOrderTimeRow>
                    <AvgOrderTimeLabel>
                        <AvgDeliveryTimeImg src={AvgDeliveryTimeIcon} />
                        Ortalama Teslimat Süresi
                    </AvgOrderTimeLabel>
                    <AvgOrderTimeValue>
                        {loading ? <Spin /> : renderAvgDeliveryTime()}
                    </AvgOrderTimeValue>
                </AverageOrderTimeRow>
                {!onDateChange && (
                    <TimeRangeFilter
                        dateType={dateType}
                        selectFieldOnChange={value => {
                            setStartDate("");
                            setEndDate("");
                            setDateType(value);
                        }}
                        rangePickerOnChange={formatString => {
                            setStartDate(formatString[0]);
                            setEndDate(formatString[1]);
                        }}
                    />
                )}
            </StatsHeader>

            <DeliveryStatsRow gutter={16}>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=current");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={ActiveOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderActiveOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Aktif</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=inQueue");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={WaitingOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderWaitingOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Bekleyen</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push(
                            "/musteri/siparislerim?page=1&city=all&orderType=past&deliveryStatus=canceled"
                        );
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={CanceledOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderCanceledOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>İptal</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock
                    span={4}
                    onClick={() => {
                        history.push("/musteri/siparislerim?page=1&city=all&orderType=past");
                    }}
                    style={{marginBottom: "16px"}}
                >
                    <DeliveryStatsIcon src={DeliveredOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderDeliveredOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Tamamlanmış</DeliveryStatsLabel>
                </DeliveryStatsBlock>
                <DeliveryStatsBlock span={4} style={{marginBottom: "16px"}}>
                    <DeliveryStatsIcon src={TotalOrderIcon} />
                    <DeliveryStatsValue>
                        {loading ? <Spin /> : renderTotalOrderCount()}
                    </DeliveryStatsValue>
                    <DeliveryStatsLabel>Toplam Paket</DeliveryStatsLabel>
                </DeliveryStatsBlock>
            </DeliveryStatsRow>
        </Wrapper>
    );
};
